import { defineMutation, useMutation, useQueryCache } from '@pinia/colada';
import { useRoute } from 'vue-router';

import { getPropertyStatisticsQueryKey, portfolioQueryKey } from '@tallo/investor/property';

import { CancelShowingDto } from '../interfaces/cancel-showing.interface';
import { showingsQueryKey } from '../queries/showings.query';
import showingService from '../services/showings.service';

export const useCancelShowing = defineMutation(() => {
  const route = useRoute();

  return useMutation({
    mutation(payload: { showingId: string; cancelDto: CancelShowingDto }) {
      return showingService.cancel(payload.showingId, payload.cancelDto);
    },
    async onSuccess() {
      const queryCache = useQueryCache();

      queryCache.invalidateQueries({ key: getPropertyStatisticsQueryKey(route.params.propertyId as string) });
      queryCache.invalidateQueries({ key: [portfolioQueryKey] });
      await queryCache.invalidateQueries({ key: [showingsQueryKey] });
    },
  });
});
